<template>
  <div>
    <!-- Diálogo para exibir todas as empresas -->
    <el-dialog class="card-modal" :visible.sync="dialogVisivel" title="Lista Completa de Empresas vinculadas">
      <el-table :data="empresasDialog.map((empresa, index) => ({ id: index + 1, nome: empresa }))" 
      class="p-table"
        style="width: 100%"
        stripe
        border
        size="mini">
        <el-table-column prop="id" label="" width="50" align="center" />
        <el-table-column prop="nome" label="Nome da Empresa" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="fecharDialog">Fechar</el-button>
      </span>
    </el-dialog>

  <ContainerCard id="TableContasBancarias" icon="fa-money-check-alt" title="Contas bancárias">
    <b-card>
      <el-table v-loading="carregando" :data="dados"
        class="p-table"
        style="width: 100%"
        stripe
        border
        size="mini">
        <el-table-column prop="nomeGrupo" label="Grupo"></el-table-column>
        <el-table-column label="Empresas">
          <template #default="{ row }">
            <div>
              <span v-for="(empresa, index) in row.empresasVinculada.slice(0, 3)" :key="empresa.id">
                {{ empresa }} <br />
              </span>
              <el-button 
              style="margin-top:10px;"
                v-if="row.empresasVinculada.length > 1" 
                type="primary" 
                text 
                size="mini"
                @click="abrirDialog(row.empresasVinculada)">
                Ver todas ({{ row.empresasVinculada.length }})
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="banco" label="Banco" width="170"></el-table-column>
        <el-table-column prop="nomeConta" label="Conta"></el-table-column>
        <el-table-column prop="numero" label="Número" width="100"
        align="center"></el-table-column>
        <el-table-column prop="digito" label="Digito" 
          width="60"
          align="center"></el-table-column>
      </el-table>
    </b-card>
  </ContainerCard>
  </div>
</template>

<script>
import ContainerCard from '@/components/shared/ContainerCard'

export default {
  components: {
    ContainerCard
  },
  props: {
    dados: Array,
    carregando: Boolean
  },
  data() {
    return {
      dialogVisivel: false,
      empresasDialog: []
    }
  },
  methods: {
    abrirDialog(empresas) {
      this.empresasDialog = empresas;
      this.dialogVisivel = true;
    },
    fecharDialog() {
      this.dialogVisivel = false;
    }
  }
};
</script>
